import { render } from "./SettingsOptionList.vue?vue&type=template&id=becfc772&scoped=true"
import script from "./SettingsOptionList.vue?vue&type=script&lang=js"
export * from "./SettingsOptionList.vue?vue&type=script&lang=js"

import "./SettingsOptionList.vue?vue&type=style&index=0&id=becfc772&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-becfc772"

export default script